export default __webpack_public_path__ + "static/media/Background_log_08.a9c649bf.png";